import IconBackdrop from './IconBackdrop';

export default IconBackdrop;
